import type { ErrorOption, FieldValues } from 'react-hook-form';

export type ApiError<ApiFields = string> = {
  type: string;
  message: string;
  errors?: {
    invalid?: ApiFields[];
  };
};

export type ApiErrorFormErrors<FormFields extends keyof FieldValues, ApiFields = FormFields> = {
  [key: string]: (error: ApiError<ApiFields>) => {
    key: FormFields | 'root' | `root.${string}`;
    error: ErrorOption;
  };
};

export function buildApiFormErrors<FormFields extends keyof FieldValues, ApiFields = FormFields>(
  errors: ApiErrorFormErrors<FormFields, ApiFields>,
  defaultError: {
    key: FormFields | 'root' | `root.${string}`;
    error: ErrorOption;
  } = {
    key: 'root.unknown',
    error: { message: '予期しないエラーが発生しました' },
  }
) {
  return (error: ApiError<ApiFields>) => ({
    key: errors[error.type]?.(error).key ?? defaultError.key,
    error: errors[error.type]?.(error).error ?? defaultError.error,
  });
}
